import { render, staticRenderFns } from "./VipDialog.vue?vue&type=template&id=34b55671&scoped=true"
import script from "./VipDialog.vue?vue&type=script&lang=js"
export * from "./VipDialog.vue?vue&type=script&lang=js"
import style0 from "./VipDialog.vue?vue&type=style&index=0&id=34b55671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b55671",
  null
  
)

export default component.exports